import { render } from "./App.vue?vue&type=template&id=13a8aac8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=13a8aac8&lang=css"

import exportComponent from "/Volumes/Work/1Gate/1Gate/1gate_check_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__